import { Component, OnInit  } from '@angular/core';
import { User } from '../../shared/models/user.model';
import { AuthenticationService } from '../../shared/_services/authentication.service';
import { UserService } from '../../shared/_services/user.service';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { OfficeService } from '../../shared/_services/office.service';
import { Office } from '../../shared/models/missingdata.model';
import { UserRoles } from '../../shared/models/roles.model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  currentUser: User;
  userFromApi: User;
  isOfficeUser: boolean = false;
  isAgent: boolean = false;
  returnUrl: string;
  offices: Office[];
  roles: UserRoles[];

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private officeService: OfficeService,
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    //console.log(this.currentUser);
  }
  ngOnInit() { 
    this.validarRedireccion(this.currentUser);
    this.isOfficeUser = this.validateUserOffice();
    this.isAgent = this.validateAgent();

    this.officeService.getOffices()
      .subscribe(res => {
        this.offices = res;
      });

    this.userService.getRoles()
      .subscribe(res => {
        this.roles = res;
      });
  }

  validarRedireccion(data: User) {
    //Valida primer ingreso   
    if (data.firstEntryDate == null) {
      this.returnUrl = '/login/first-time';
      this.router.navigate([this.returnUrl]);
    }
    //Valida si la contraseñaes temporal y no es el primer ingreso  , recupero contraseña o le generaron contraseña
    if (data.temporalPassword || data.expiredPassword) {
      this.returnUrl = '/login/change-password';
      this.router.navigate([this.returnUrl]);
    }
    return true;
  }

  validateUserOffice() {
    if (this.currentUser.fkUserRole == 5) {
      return true;
    }
    return false;
  }

  validateAgent() {

    if (this.currentUser.fkUserRole == 6) {
      return true;
    }
    return false;
  }
}
